import React from "react";
import { Col } from "react-bootstrap";
import styled from "styled-components";

export default function HrText({ text, fullWidth }) {
  return (
    <Col sm={fullWidth ? 12 : 11}>
      <Hr text={text} />
    </Col>
  );
}

const Hr = styled.hr`
  margin: 2rem 0;
  position: relative;
  height: 1px;
  background: #dde0e4;
  overflow: visible;

  &::before {
    content: "${(props) => props.text}";
    background: #fff;
    color: #09090a;
    padding: 0rem 1rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
